import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveStrategicAxisRequestFailure(strategicAxis) {
      const state = getState().find(
        ({ strategicAxis: { uuid } }) => strategicAxis.uuid === uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveStrategicAxisRequestPending(strategicAxis) {
      const state = getState().find(
        ({ strategicAxis: { uuid } }) => uuid === strategicAxis.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveStrategicAxisRequestSuccess(strategicAxis) {
      const state = getState().find(
        ({ strategicAxis: { uuid } }) => uuid === strategicAxis.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
